import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { getJwtToken, passworlessUpdate } from "../../../utilities/API/supertokenServices"
import { toast } from "react-toastify"

export const passwordlessUpdateService = createAsyncThunk(
    'fetchPreAuthFAF', passworlessUpdate
)

const initialState = {
    loader: false
}

const passwordlessUpdateSlice = createSlice({
    name: 'preAuth',
    initialState,
    reducers: {
        resetPasswordlessUpdate: (state) => {
            state.loader = false
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(passwordlessUpdateService.pending, (state, action) => {
                state.loader = true
            })
            .addCase(passwordlessUpdateService.fulfilled, (state, action) => {
                state.loader = false
            })
            .addCase(passwordlessUpdateService.rejected, (state, action) => {
                toast.error(action.error.message)
                state.loader = false
            })
    }
})

export const { resetPasswordlessUpdate } = passwordlessUpdateSlice.actions

export default passwordlessUpdateSlice.reducer